/*
 | =========================================================
 | This File is for member hub rewards API services handling
 | =========================================================
 */
import { ApiService } from './api.service'

class RewardsService {
  constructor () {
    this.request = new ApiService()
  }

  /*
   * Rewards List API service
   * @param formData
   * @returns {*}
   */
  list = formData => {
    return this.request.get('/rewards', { params: formData })
  }

  /*
   * Activating a reward API service
   * @param rewardId
   * @returns {*}
   */
  activate = rewardId => {
    return this.request.post(`/rewards/activate/${rewardId}`)
  }

  /*
   * Archive a reward API service
   * @param rewardId
   * @returns {*}
   */
  archive = rewardId => {
    return this.request.post(`/rewards/archive/${rewardId}`)
  }

  /*
   * Un Archive a reward API service
   * @param rewardId
   * @returns {*}
   */
  unArchive = rewardId => {
    return this.request.post(`/rewards/un-archive/${rewardId}`)
  }
}

export default RewardsService
